import PropTypes from 'prop-types';
import React from 'react';
import { modelNameTransformer } from 'pubweb-smokey/dist/utils/modelNameTransformer';
import { formatNumberWithCommas } from 'pubweb-smokey/dist/utils/formatters';
import { DXFavoritesContext } from '@contexts/DXFavoritesContext';
import FavoritingHeart from '@components/Shared/Favoriting/FavoritingHeart';
import { pushGTMEvent } from 'pubweb-smokey/dist/utils/analytics';
import { HeadingMobileStyles } from './HeadingMobile.styled';
import HomeSpecs from './HomeSpecs';
import TopFavoriteBanner from './TopFavoriteBanner';

const HeadingMobile = ({ homeDetails, price, isInStock }) => {
  /* eslint-disable react/no-unescaped-entities */
  return (
    <HeadingMobileStyles>
      <div className="home-details-heading home-details-heading-mobile">
        {isInStock && (
          <div className="stock-indicator label">
            <div className="in-stock-dot">&nbsp;</div> In Stock
          </div>
        )}

        <div className="home-info-mobile">
          <div>
            <h1 className="h2">
              {modelNameTransformer(homeDetails.modelDescription)}
            </h1>
            {price && (
              <h5>${formatNumberWithCommas(price)}'s* Before Options</h5>
            )}
            <div className="see-below">
              <span
                tabIndex="0"
                onClick={() => {
                  const el = document.getElementById('disclaimer');
                  window.scroll({ top: el.offsetTop - 75, left: 0 });
                }}
              >
                See below for complete pricing details
              </span>
            </div>
          </div>

          <div className="favoriting-heart-container">
            <DXFavoritesContext.Consumer>
              {({ state, actions }) => {
                return (
                  <FavoritingHeart
                    isFavorited={
                      !!state.favoriteModels?.filter(
                        (faveModels) =>
                          faveModels.modelNumber === homeDetails.modelNumber
                      )[0]
                    }
                    onClick={() => {
                      actions.toggleFavoriteModel(homeDetails.modelNumber);
                      pushGTMEvent('clickFavoritesHeart');
                    }}
                  />
                );
              }}
            </DXFavoritesContext.Consumer>
          </div>
        </div>

        <TopFavoriteBanner modelNumber={homeDetails?.modelNumber} />

        <div className="home-specs-container">
          <HomeSpecs homeDetails={homeDetails} />
        </div>
      </div>
    </HeadingMobileStyles>
  );
  /* eslint-enable react/no-unescaped-entities */
};

HeadingMobile.propTypes = {
  homeDetails: PropTypes.shape({
    modelDescription: PropTypes.any,
    modelNumber: PropTypes.any,
  }),
  isInStock: PropTypes.any,
  price: PropTypes.any,
};

export default HeadingMobile;
